import React     from 'react';
import PropTypes from 'prop-types';

import { ChangePlanAcme }      from './change-plan-acme';
import { ChangePlanBm }        from './change-bm/change-plan-bm';
import { ChangePlanQkn }       from './change-qkn/change-plan-qkn';
import { ReactivateSimpModal } from './reactivate-simp-modal';
import { ForceClose }          from '../force-close';
import { useGlobalCtx }        from '../../../context/ctx-hook';

const ChangePlanModal = (props) => {
  const {state} = useGlobalCtx();
  const COUNTRY = state.country;
  const QKN_SUB = state.subscriptions[`quicken-${COUNTRY}`];

  if (props.ctx.product === 'acme' && state?.subscriptions?.acme) {
    const SUB = state?.subscriptions?.acme;
    if (SUB?.active) {
      return SUB.renewalFrequency === 'P1M'
        ? <ChangePlanAcme {...props} />
        : <ForceClose onClose={props.onClose}/>;
    } else {
      return <ReactivateSimpModal {...props} />;
    }
  } else if (props.ctx.product === 'billmanager' && QKN_SUB.active) {
    return <ChangePlanBm {...props} />;
  } else if (QKN_SUB && props.ctx.product.includes('quicken')) {
    return <ChangePlanQkn {...props} />;
  } else {
    return <ForceClose onClose={props.onClose}/>;
  }
};

ChangePlanModal.displayName = 'ChangePlanModal';

ChangePlanModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  ctx:     PropTypes.shape({
    product: PropTypes.string.isRequired
  })
};

export { ChangePlanModal };
